import React from 'react'
import cn from 'classnames'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import { OfferType } from '@monorepo/interfaces'
import { User } from '@monorepo/hooks'
import { Currency } from '@monorepo/components/common'
import { formatDeliveryTime } from '@monorepo/core/helpers'
import { CartIcon, ExpectedIcon } from './icons'

import { PriceCalculatorInfo } from './PriceCalculatorInfo'
import { DeliveryInfo } from './DeliveryInfo'
import { RefundInfo } from './RefundInfo'
import { QualityInfo } from './QualityInfo'
import { PhotoInfo } from './PhotoInfo'
import { AddToCartButton } from 'App/View/Search/Components'
import { formatTime } from './utils'

type PropsType = {
  item: OfferType
}

export const OfferItem: React.FC<PropsType> = ({ item }) => {
  const { user } = User.useUser()

  return (
    <div className="d-flex align-items-center align-self-stretch flex-shrink-0 m-0 my-xl-2">
      {/* <div className="product-card__prices">{item.amountString}</div> */}
      <div className="product-card__prices flex-row-reverse justify-content-between align-items-center">
        <span>{item.amountString}</span>
        {/* {item.isStock && item.stockName && (
          <div
            className={cn(
              'status-badge',
              'status-badge--has-text',
              'status-badge--style--success'
            )}
          >
            <div className="status-badge__body">
              <div className="status-badge__text">{item.stockName}</div>
            </div>
          </div>
        )} */}
        <span className="d-flex justify-content-center align-items-center">
          <DeliveryInfo
            item={item}
            tooltip="Статистика поставок"
            variant="secondary"
            className="mr-1"
          />
          <RefundInfo item={item} pill variant="secondary" className="mr-1" />
          <QualityInfo item={item} pill variant="danger" className="mr-1" />
          <PhotoInfo
            item={item}
            tooltip="Изображения детали"
            variant="secondary"
            className="mr-1"
          />
        </span>
      </div>
      <div
        className={cn(
          'product-card__prices',
          'd-flex',
          // 'flex-row-reverse',
          // 'justify-content-between',
          'px-1',
          'justify-center',
          'align-items-center'
        )}
      >
        <div
          className={cn(
            'status-badge',
            'status-badge--has-text',
            item.isStock
              ? 'status-badge--style--success'
              : 'status-badge--style--warning'
          )}
        >
          <div className="status-badge__body">
            <div className="status-badge__text">
              {item.isStock && item.stockName ? (
                <div
                  className={cn(
                    'status-badge',
                    'status-badge--has-text',
                    'status-badge--style--success'
                  )}
                >
                  {item.stockName}
                  {item.deliveryTime > 0 && (
                    <>
                      &nbsp;
                      <div
                        className="indicator__counter"
                        style={{ right: -5, top: -5 }}
                      >
                        +{formatDeliveryTime(item.deliveryTime)}
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <>{formatDeliveryTime(item.deliveryTime) ?? '?'}</>
              )}
              {/* {item.deliveryTime === 0 && item.isStock
                ? 'На складе'
                : formatDeliveryTime(item.deliveryTime) || <>?</>} */}
            </div>
          </div>
          {/* <div className="status-badge__body">
            <div className="status-badge__text">
              {item.deliveryTime === 0 && item.isStock
                ? 'На складе'
                : formatDeliveryTime(item.deliveryTime) || <>?</>}
            </div>
          </div> */}
        </div>
      </div>
      <div className="product-card__prices">
        <div
          className={cn(
            'product-card__price',
            'product-card__price--current',
            'd-flex',
            'flex-row-reverse',
            'justify-content-between',
            'align-items-center',
            'w-100',
            'pl-2'
          )}
        >
          <span>
            <Currency value={item.price} />
          </span>
          {(user.isAdmin || user.isImpersonated) && (
            <PriceCalculatorInfo offer={item} variant="secondary" />
          )}
        </div>
      </div>
      <OverlayTrigger
        placement="auto"
        overlay={
          <Tooltip id={`offer-tooltip-${item.itemKey}`}>
            {item.expectedAt
              ? `Ожидается ${formatTime(item.expectedAt)}`
              : 'Добавить в корзину'}
          </Tooltip>
        }
      >
        {item.expectedAt ? (
          <div
            className="product-card__addtocart-icon"
            aria-label={`Ожидается ${formatTime(item.expectedAt)}`}
          >
            <ExpectedIcon expected={item.expectedAt} />
          </div>
        ) : (
          <AddToCartButton
            item={item}
            className="product-card__addtocart-icon"
            aria-label="Добавить в корзину"
          >
            <CartIcon />
          </AddToCartButton>
        )}
      </OverlayTrigger>
      {/* <button
        className="product-card__addtocart-full"
        type="button"
        onClick={() => checkPermissions({ guest: false }) && showModalHandler()}
      >
        Добавить в корзину
      </button> */}
      {/* <button className="product-card__wishlist" type="button">
        <WishlistIcon />
        <span>Add to wishlist</span>
      </button>
      <button className="product-card__compare" type="button">
        <CompareIcon />
        <span>Add to compare</span>
      </button> */}
    </div>
  )
}
